import Container from '@material-ui/core/Container'
import CssBaseline from '@material-ui/core/CssBaseline'
import LoginTemplate from 'components/templates/LoginTemplate'
import React from 'react'

const Login = () => {
    return (
        <Container component='main' maxWidth='xs'>
            <CssBaseline />
            <LoginTemplate />
        </Container>
    )
}

export default Login
